angular.module('ecrd.queries').filter('queriesFieldValue', [
    'elementValueFilter',
    'dateFormatFilter',
    'gettextCatalog',
    function(elementValueFilter, dateFormatFilter, gettextCatalog) {
        return function(fieldValue) {
            if (fieldValue.encrypted) {
                return '<span class="encrypted-value">' + gettextCatalog.getString('Encriptado') + '</span>';
            }

            if (['date', 'datetime'].indexOf(fieldValue.type) > -1) {
                return dateFormatFilter(fieldValue.value, fieldValue.inputFormat);
            }

            return elementValueFilter(fieldValue);
        };
    },
]);
